// TSV concept scheme export worker
function tsvExport() {

    const SKOS = "http://www.w3.org/2004/02/skos/core#";
    const OWL = "http://www.w3.org/2002/07/owl#";

    onmessage = function (message) {
        const { id, data, options, template, mode } = message.data;
        let tsvData = mode === "conceptScheme" ? tsvSchemeFunction(id, data, options, template) : tsvCollectionFunction(id, data, options, template);
        postMessage(tsvData);
        // Clear the data
        tsvData = undefined;
    };

    function sortConcepts(data, concepts, lang) {
        return concepts.sort((a, b) => {
            const aConcept = data.graph.find(item => item.id === a);
            const bConcept = data.graph.find(item => item.id === b);
            // toString to handle multiple pref labels in same language
            const aText = aConcept && aConcept.prefLabel && aConcept.prefLabel[lang] ?
                Array.isArray(aConcept.prefLabel[lang]) ?
                    aConcept.prefLabel[lang].sort().toString().toLowerCase()
                    :
                    aConcept.prefLabel[lang].toString().toLowerCase()
                :
                "";
            const bText = bConcept && bConcept.prefLabel && bConcept.prefLabel[lang] ?
                Array.isArray(bConcept.prefLabel[lang]) ?
                    bConcept.prefLabel[lang].sort().toString().toLowerCase()
                    :
                    bConcept.prefLabel[lang].toString().toLowerCase()
                :
                "";
            if (aText < bText) return -1;
            return 1;
        });
    }

    function processNarrower(rows, data, parentConcept, lang, circular = [], indent = 1) {
        sortConcepts(data, parentConcept.narrower, lang)
            .forEach(concept => {
                if (!circular.includes(concept)) {
                    const conceptData = data.graph.find(item => item.id === concept);
                    let row = [concept];
                    for (let i = 0; i < indent; i++) { row.push(null); }
                    const label = conceptData && conceptData.prefLabel && conceptData.prefLabel[lang] ?
                        conceptData.prefLabel[lang]
                        :
                        'No value in selected language';
                    row.push(label);
                    rows.push(row);
                    const newCircular = circular.slice();
                    newCircular.push(concept);
                    if (conceptData && conceptData.narrower) processNarrower(rows, data, conceptData, lang, newCircular, indent + 1);
                }
            });
    }

    function computeConceptRows(conceptData, properties, languages) {
        let rowCount = 1;
        if (!conceptData) return rowCount;
        properties.forEach((prop, propIndex) => {
            const alias = prop.indexOf(SKOS) === 0 ?
                prop.substring(SKOS.length)
                :
                prop.indexOf(OWL) === 0 ?
                    prop.substring(OWL.length)
                    :
                    prop === "http://www.w3.org/1999/02/22-rdf-syntax-ns#type" ?
                        "type"
                        :
                        prop;
            const data = conceptData[alias];
            if (data) {
                if (Array.isArray(data)) {
                    // We only want language values for this column (there may be multiple languages)
                    if (data[0]["language"]) {
                        const columnLang = languages[propIndex];
                        const columnValues = data.filter(item => item.language === columnLang);
                        if (columnValues.length > rowCount) rowCount = columnValues.length;
                    }
                    else {
                        if (data.length > rowCount) rowCount = data.length;
                    }
                }
                else if (typeof data === 'object') {
                    if (data["id"]) {
                        // Do nothing for now as should only be one value - i.e one row
                    }
                    else {
                        const langItems = data[languages[propIndex]];
                        const langItemsLength = Array.isArray(langItems) ? langItems.length : 1;
                        if (langItemsLength > rowCount) rowCount = langItemsLength;
                    }
                }
            }
        });
        return rowCount;
    }

    function computeAdditionalRows(data, rows, properties, languages) {
        let rowsWithContent = [];
        rows.forEach(row => {
            const rowLength = row.length;
            const concept = row[0];
            const conceptData = data.graph.find(item => item.id === concept);
            const rowCount = computeConceptRows(conceptData, properties, languages);
            // Add columns for properties
            for (let i = 1; i < properties.length; i++) { row.push(null); }
            const rowIndex = rowsWithContent.length;
            rowsWithContent.push(row);
            if (rowCount > 1) {
                // Add additional rows to handle multiple values on a property
                for (let i = 1; i < rowCount; i++) {
                    const additionalRow = [];
                    // Pad out new row for all needed columns
                    for (let j = 1; j < row.length + properties.length; j++) { additionalRow.push(null); }
                    rowsWithContent.push(additionalRow);
                }
            }
            // Now populate additional property data
            properties.forEach((prop, propIndex) => {
                const alias = prop.indexOf(SKOS) === 0 ?
                    prop.substring(SKOS.length)
                    :
                    prop.indexOf(OWL) === 0 ?
                        prop.substring(OWL.length)
                        :
                        prop === "http://www.w3.org/1999/02/22-rdf-syntax-ns#type" ?
                            "type"
                            :
                            prop;
                const propData = conceptData ? conceptData[alias] : null;
                const columnLang = languages[propIndex];

                if (propData !== null) {
                    if (Array.isArray(propData)) {
                        propData
                            // If language values filter for this column
                            .filter(dataValue => !dataValue["language"] || dataValue["language"] === columnLang)
                            .sort((a, b) => {
                                const valueA = a["id"] ?
                                    a["id"]
                                    :
                                    a["@value"] ?
                                        a["@value"]
                                        :
                                        a;
                                const valueB = b["id"] ?
                                    b["id"]
                                    :
                                    b["@value"] ?
                                        b["@value"]
                                        :
                                        b;
                                return valueA < valueB ? -1 : 1;
                            })
                            .forEach((dataValue, dataValueIndex) => {
                                if (dataValue["id"]) {
                                    rowsWithContent[rowIndex + dataValueIndex][rowLength + propIndex] = dataValue["id"];
                                }
                                else {
                                    const cleanedUpText = dataValue["@value"] ?
                                        escapeText(dataValue["@value"])
                                        :
                                        typeof dataValue === "string" ?
                                            escapeText(dataValue)
                                            :
                                            dataValue;
                                    rowsWithContent[rowIndex + dataValueIndex][rowLength + propIndex] = cleanedUpText;
                                }
                            });
                    }
                    else if (typeof propData === 'object') {
                        if (propData["id"]) {
                            rowsWithContent[rowIndex][rowLength + propIndex] = propData["id"];
                        }
                        else if (propData["@value"]) {
                            rowsWithContent[rowIndex][rowLength + propIndex] = propData["@value"];
                        }
                        else {
                            const langItems = propData[languages[propIndex]];
                            const langItemsNormalised = Array.isArray(langItems) ? langItems : [langItems];
                            langItemsNormalised.sort().forEach((dataValue, dataValueIndex) => {
                                // Escape certain characters
                                const cleanedUpText = escapeText(dataValue);
                                rowsWithContent[rowIndex + dataValueIndex][rowLength + propIndex] = cleanedUpText;
                            });
                        }
                    }
                    else {
                        rowsWithContent[rowIndex][rowLength + propIndex] = propData;
                    }
                }
            });
        });
        return rowsWithContent;
    }

    function escapeText(text) {
        if (!text) return "";
        text = text.replace(/\\/g, '\\\\');
        text = text.replace(/\n/g, "\\n");
        text = text.replace(/\t/g, "\\t");
        text = text.replace(/\r/g, "\\r");
        return text;
    }

    function computeDisplayName(iri, options) {
        const objectProperties = options.objectProperties;
        const datatypeProperties = options.datatypeProperties;
        const additionalProperties = options.associations || [];
        const dp = Object.keys(datatypeProperties).find(prop => datatypeProperties[prop].iri === iri);
        if (dp !== undefined) {
            return datatypeProperties[dp] ?
                datatypeProperties[dp].displayName
                :
                iri;
        }
        const op = Object.keys(objectProperties).find(prop => objectProperties[prop].iri === iri);
        if (op !== undefined) {
            return objectProperties[op] ?
                objectProperties[op].displayName
                :
                iri;
        }
        const ap = additionalProperties.find(prop => prop.iri === iri);
        if (ap !== undefined && ap.label && ap.label[options.defaultLang]) {
            return Array.isArray(ap.label[options.defaultLang]) ?
                ap.label[options.defaultLang][0]
                :
                ap.label[options.defaultLang];
        }
        return iri;
    }

    function computeFinalRows(data, rows, options, template) {

        const includeHeaderRow = template.tsvTemplateOption
            && template.tsvTemplateOption.includes("https://grafsync.graphifi.com/schema/tsv/includeheader");
        let properties = [];
        let languages = [];
        template.tsvColumnProperty.forEach((prop, index) => {
            if (prop !== "https://grafsync.graphifi.com/schema/tsv/hierarchy" &&
                prop !== "https://grafsync.graphifi.com/schema/tsv/concepts" &&
                prop !== "https://grafsync.graphifi.com/schema/tsv/IRI") {
                properties.push(prop);
                languages.push(template.tsvColumnLanguage[index]);
            }
        });

        let finalRows = rows;
        let headerRow = ["Concept IRI"];
        // To add columns for additional properties we need to know the longest row
        const maxDepth = rows.reduce((r, s) => Math.max(s.length, r), []);
        for (let i = 1; i < maxDepth; i++) { headerRow.push("Concept (Level " + i + ")"); }

        // So we are adding columns for all non hierarchy/IRI columns (which we splice in later)
        if (properties && properties.length > 0) {
            for (let p = 0; p < properties.length; p++) {
                const prop = properties[p];
                const displayName = computeDisplayName(prop, options);
                headerRow.push(displayName);
            }
            // Pad out rows with cells to maximum width for hiearchy
            rows.forEach(row => {
                if (row.length < maxDepth) {
                    for (let i = row.length; i < maxDepth; i++) { row.push(null); }
                }
            });
            finalRows = computeAdditionalRows(data, rows, properties, languages);
        }

        if (includeHeaderRow) {
            finalRows.splice(0, 0, headerRow);
        }

        // Now we need to sort out hierachies, IRIs and columns
        const withColumns = finalRows.map(row => {
            const columnRow = [];
            let propIndex = 0;
            template.tsvColumnProperty.forEach(cp => {
                if (cp === "https://grafsync.graphifi.com/schema/tsv/IRI") {
                    columnRow.push(row[0]);
                }
                else if (cp === "https://grafsync.graphifi.com/schema/tsv/hierarchy" || cp === "https://grafsync.graphifi.com/schema/tsv/concepts") {
                    const hr = row.slice(1, maxDepth);
                    columnRow.push.apply(columnRow, hr);
                }
                else {
                    columnRow.push(row[maxDepth + propIndex]);
                    propIndex++;
                }
            });
            return columnRow;
        });

        return withColumns.map(row => row.join("\t")).join("\n");
    }

    function tsvSchemeFunction(id, data, options, template) {

        // We sort by the first column that has a language value
        const langColumnIndex = template.tsvColumnProperty.findIndex(cp => cp === "https://grafsync.graphifi.com/schema/tsv/hierarchy" || cp === "https://grafsync.graphifi.com/schema/tsv/concepts");
        const lang = langColumnIndex >= 0 ?
            template.tsvColumnLanguage[langColumnIndex]
            :
            options.defaultLang;
        const scheme = data.graph && data.graph.find(item => item.id === id);

        let rows = [];
        if (scheme) {
            sortConcepts(data, scheme.hasTopConcept, lang)
                .forEach(concept => {
                    let row = [concept];
                    const conceptData = data.graph.find(item => item.id === concept);
                    const label = conceptData && conceptData.prefLabel && conceptData.prefLabel[lang] ?
                        conceptData.prefLabel[lang]
                        :
                        'No value in selected language';
                    row.push(label);
                    rows.push(row);
                    if (conceptData && conceptData.narrower) processNarrower(rows, data, conceptData, lang, []);
                });
        }

        const finalData = computeFinalRows(data, rows, options, template);
        return finalData;
    }

    function tsvCollectionFunction(id, data, options, template) {

        // We sort by the first column that has a language value
        const langColumnIndex = template.tsvColumnProperty.findIndex(cp => cp === "https://grafsync.graphifi.com/schema/tsv/hierarchy" || cp === "https://grafsync.graphifi.com/schema/tsv/concepts");
        const lang = langColumnIndex >= 0 ?
            template.tsvColumnLanguage[langColumnIndex]
            :
            options.defaultLang;
        const collection = data.graph && data.graph.find(item => item.id === id);
        const memberProp = options.ordered ? "memberList" : "member";

        let rows = [];
        if (collection && collection[memberProp]) {
            let memberData = collection[memberProp];
            if (!options.ordered) {
                memberData.sort((a, b) => {
                    const aConcept = data.graph.find(item => item.id === a);
                    const bConcept = data.graph.find(item => item.id === b);
                    const aText = aConcept.prefLabel && aConcept.prefLabel[lang] ? aConcept.prefLabel[lang].toString().toLowerCase() : "";
                    const bText = bConcept.prefLabel && bConcept.prefLabel[lang] ? bConcept.prefLabel[lang].toString().toLowerCase() : "";
                    if (aText < bText) return -1;
                    return 1;
                });
            }
            memberData.forEach(concept => {
                let row = [concept];
                const conceptData = data.graph.find(item => item.id === concept);
                const label = conceptData && conceptData.prefLabel && conceptData.prefLabel[lang] ?
                    conceptData.prefLabel[lang]
                    :
                    'No value in selected language.\n';
                row.push(label);
                rows.push(row);
            });
        }

        const finalData = computeFinalRows(data, rows, options, template);
        return finalData;
    }

}

export default tsvExport;